import { render, staticRenderFns } from "./KiwiBnc.vue?vue&type=template&id=e501b820&"
import script from "./KiwiBnc.vue?vue&type=script&lang=js&"
export * from "./KiwiBnc.vue?vue&type=script&lang=js&"
import style0 from "./KiwiBnc.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports